/* eslint-disable no-loop-func */
import { fetch } from "../utils/scsFetch";
import { URL_SUPPLIER_API, URL_INTEGRATION_API } from '../utils/constEnvVariables';
import { URL_SURVEY_API } from '../utils/constEnvVariables';
import {TIER2_BOUNDARIES_TYPES } from '../utils/surveyLiterals';

export async function validateSupplierNumbers(accessToken, supplierNumbersArray) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ supplierNumbers: supplierNumbersArray })
    }

    let invalidSuppNumbers = [];
    return await fetch(URL_SUPPLIER_API, requestOptions)
        .then(response => {
            if (!response || response.length <= 0) {
                return supplierNumbersArray
            } else {
                supplierNumbersArray.forEach(element => {
                    let index = response.find(sn => element.trim() === sn.supplierNumber.toString());
                    if (!index)
                        invalidSuppNumbers.push(element);
                });
                return invalidSuppNumbers;
            }
        })
        .catch(error => {
            console.log(error);
            return supplierNumbersArray;
        });
}

export async function validateSupplierNumbersByChunk(accessToken, supplierNumbersArray) {
    let chunkSize = 1000;
    let arrayResult = [];
    let startIdex = 0;
    let endIndex = chunkSize;
    let resultChunk;
    for (let i = 0; startIdex < supplierNumbersArray.length; i++) {
        if (startIdex < supplierNumbersArray.length && endIndex < supplierNumbersArray.length) {
            resultChunk = supplierNumbersArray.slice(startIdex, endIndex);
        } else if (startIdex < supplierNumbersArray.length) {
            resultChunk = supplierNumbersArray.slice(startIdex);
        }
        if (resultChunk && resultChunk.length > 0) {
            await validateSupplierNumbers(accessToken, resultChunk).then(arrayInvalid => {
                if (arrayInvalid && arrayInvalid.length > 0) {
                    arrayResult = [...arrayResult, arrayInvalid];
                }
            }).catch(error => {
                console.log(error);
                arrayResult = [...arrayResult, resultChunk];
            });
        }
        startIdex = startIdex + chunkSize;
        endIndex = endIndex + chunkSize;
    }
    return arrayResult;
}

export async function getCountry(accessToken) {
    const requestOptions = { method: "GET", headers: { Authorization: `Bearer ${accessToken}` } };
    const pathParam = "surveys/external";
    
    return await fetch(`${URL_SURVEY_API}/${pathParam}/countries`, requestOptions)
        .then(resp => {
            return resp !== undefined ?
                Object.values(resp).filter(res => res.localeCode === 'en_US')
                : [];
        }
        ).catch(error => console.log(error));
}

export async function getBoundary(accessToken, countryCode) {
    const requestOptions = { method: "GET", headers: { Authorization: `Bearer ${accessToken}` } };
    const pathParam = "surveys/external";

    return await fetch(`${URL_SURVEY_API}/${pathParam}/boundaries?iso2CountryCode=${countryCode}`, requestOptions)
        .then(resp => {
            return resp !== undefined ?
                Object.values(resp).filter(res => TIER2_BOUNDARIES_TYPES.includes(res.type))
                : [];
        }).catch(error => console.log(error));
}

export async function getDeereContacts(inputParam, accessToken){
    const reqOptions = {
        method: "GET",
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    }
    return await fetch(`${URL_INTEGRATION_API}/integration/deere/contact/${inputParam}`, reqOptions)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err);
            return [];
        })
}

export function templateData(accessToken, surveyId) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }
    return fetch(`${URL_SURVEY_API}/surveys/excelColumns/${surveyId}`, requestOptions)
        .then(response => {
            return response;

        });
}